import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { Bar, BarIcon } from '../../../../../panda';

import { GLYPHS } from '../../../../../constants/icons';

import { IRootState, IDispatch } from '../../../../../modules/stores';
import { OrderChangeType } from '../../../../../types/space';

import { InputTitle } from '../../../../Input';
import { PairedInputMixin, PairWithSpace } from '../styled';
import { BtnMixin } from './styled';

type IConnectProps = ReturnType<typeof mapDispatch> & ReturnType<typeof mapState>;
interface IProps extends IConnectProps, WrappedComponentProps {
  spaceId: string;
}

const OrderBtns: React.FC<IProps> = ({
  allIds,
  spaceId,
  updateSpaceOrder,
  intl: { formatMessage },
}) => (
  <>
    <InputTitle
      isSmall
      isReverse
      title={formatMessage({ id: 'sidebar.order' })}
      css={'display: block;'}
    />
    <PairWithSpace>
      <Bar isSmall includeSpaceBelow isReverse css={PairedInputMixin}>
        <BarIcon
          css={BtnMixin}
          isSmall
          isReverse
          isDisabled={allIds[0] === spaceId}
          icon={GLYPHS.SEND_BACK}
          onClick={() => updateSpaceOrder({ spaceId, change: OrderChangeType.OneBack })}
          iconSize={{ height: 16, width: 16 }}
        />
        <BarIcon
          css={BtnMixin}
          isSmall
          isReverse
          isDisabled={allIds[allIds.length - 1] === spaceId}
          icon={GLYPHS.SEND_FORWARD}
          onClick={() => updateSpaceOrder({ spaceId, change: OrderChangeType.OneForward })}
          iconSize={{ height: 16, width: 16 }}
        />
      </Bar>
      <Bar isSmall includeSpaceBelow isReverse css={PairedInputMixin}>
        <BarIcon
          css={BtnMixin}
          isSmall
          isReverse
          isDisabled={allIds[0] === spaceId}
          icon={GLYPHS.SEND_BACK}
          onClick={() => updateSpaceOrder({ spaceId, change: OrderChangeType.AllBack })}
          iconSize={{ height: 16, width: 16 }}
        />
        <BarIcon
          css={BtnMixin}
          isSmall
          isReverse
          isDisabled={allIds[allIds.length - 1] === spaceId}
          icon={GLYPHS.SEND_ALL_THE_WAY_FORWARD}
          onClick={() => updateSpaceOrder({ spaceId, change: OrderChangeType.AllForward })}
          iconSize={{ height: 16, width: 16 }}
        />
      </Bar>
    </PairWithSpace>
  </>
);

const mapState = ({ space }: IRootState) => ({
  allIds: space.allIds,
});

const mapDispatch = ({ space }: IDispatch) => ({
  updateSpaceOrder: (payload: any) => space.updateSpaceOrder(payload),
});

export default compose(
  injectIntl,
  connect(
    mapState,
    // @ts-ignore
    mapDispatch,
  ),
)(OrderBtns);
